<template>
    <div class="plan-selector-wrapper">
        <label :for="'p' + id" @click="handle(id)"></label>
        <div class="plan-selector-control">
            <div class="plan__selector">
                <input :id="'p' + id" type="checkbox" v-model="plans" :value="id" :disabled="isDisabled(id)">
                <label :for="'p' + id"></label> 
            </div><!--/plan__selector-->
            <span :class="{'status--selected': plans.includes(id)}">
                <template v-if="plans.includes(id)">{{app.labels.SELECTED}}</template>
                <template v-else>{{app.labels.SELECT_TO_COMPARE}}</template>
            </span>
        </div>
    </div><!--/plan-selector-wrapper-->
</template>

<script type="text/javascript">
import {mapActions} from 'vuex'
import {PLAN_LIMIT} from '../constants'

export default {
    data() {
        return {
            app: window.app
        }
    },
    props: ['id'],
    computed: {
        plans: {
            get () {
                return this.$store.state.plans
            },
            set (value) {                
                this.updatePlans(value)
            }
        }
    },
    methods: {
        ...mapActions([
            'updatePlans',
            'updateNoticeText'
        ]),

        setNotice(noticeText) {
            let self = this
            
            self.updateNoticeText(noticeText)
            setTimeout(() => {
                self.updateNoticeText('')
            }, 5000)
        },

        isDisabled(value) {
            return !this.plans.includes(value) && this.plans.length >= PLAN_LIMIT
        },

        handle(value) {
            if (this.isDisabled(value)) {
                this.setNotice(this.app.notices.planLimitExceeded)
            }        
        }
    }
}
</script>